<template>
  <v-col class="register default-slot" md="7" sm="12">
    <div class="top-icons">
      <a class="back-icon" v-on:click="changePage(1)">
        <font-awesome-icon icon="long-arrow-alt-left" size="lg" /> Back
      </a>
    </div>
    <h1 class="register-title">Lease Agreement</h1>
    <v-row>
      <v-col>
        <h2>Select Date Range for Lease</h2>
        <v-alert
          class="mb-1 mt-1"
          v-if="validationInfo.errorMessage"
          type="error"
          >{{ validationInfo.errorMessage }}</v-alert
        >
        <v-row>
          <v-col cols="12" sm="6">
            <DatepickerFormatted
              :date="startDate"
              label="Start date"
              :disableClearable="true"
              v-on:updateDates="updateStartDate"
            />
          </v-col>
          <v-col cols="12" sm="6">
            <DatepickerFormatted
              :date="endDate"
              label="End date"
              :disableClearable="true"
              v-on:updateDates="updateEndDate"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-btn
      class="white--text"
      large
      v-on:click="changePage(3)"
      :disabled="isDisabled"
      color="primary"
      >NEXT</v-btn
    >
    <p class="steps">STEP <b>2</b> OF <b>3</b></p>
    <footer-text />
  </v-col>
</template>

<script lang="ts">
import Vue from "vue";
import FooterText from "@/components/common/FooterText.vue";
import DatepickerFormatted from "@/components/common/inputs/DatepickerFormatted.vue";

export default Vue.extend({
  components: { FooterText, DatepickerFormatted },
  name: "LeaseRequestForm2",
  data: function () {
    return {
      startDate: ((this.$props.dates as Temporal.PlainDate[])[0] ?? null) as Temporal.PlainDate | null,
      endDate: ((this.$props.dates as Temporal.PlainDate[])[1] ?? null) as Temporal.PlainDate | null,
    };
  },
  methods: {
    updateStartDate: function (update: { date: Temporal.PlainDate | null }) {
      this.startDate = update.date;
      this.updateDates();
    },
    updateEndDate: function (update: { date: Temporal.PlainDate | null }) {
      this.endDate = update.date;
      this.updateDates();
    },
    updateDates: function () {
      if (!this.startDate || !this.endDate) return;

      const dates = [this.startDate, this.endDate].sort(Temporal.PlainDate.compare);
      this.startDate = dates[0];
      this.endDate = dates[1];
      this.$props.changeDates(dates);
    },
  },
  computed: {
    isDisabled: function () {
      return (
        !this.startDate ||
        !this.endDate ||
        !this.validationInfo.success
      );
    },
  },
  props: {
    changePage: Function,
    dates: Array,
    changeDates: Function,
    validationInfo: Object,
  },
});
</script>
